
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Client } from '@/components/clients/types';
import { EnrichedData } from '@/components/clients/enrichment-dialog/enrichmentTypes';
import { compareClientDataWithEnriched, mappableFields as globalMappableFields } from '@/components/clients/enrichment-utils';

export const useClientDataPreview = (client: Client | undefined | null): Set<keyof Client> => {
  const [fieldsWithNewData, setFieldsWithNewData] = useState<Set<keyof Client>>(new Set());

  useEffect(() => {
    const processClientForPreview = async () => {
      if (client && client.enrichment_status === 'available' && client.last_enrichment_run_id) {
        try {
          const { data: enrichmentRecord, error: fetchError } = await supabase
            .from('client_enrichment_results')
            .select('enriched_data')
            .eq('run_id', client.last_enrichment_run_id)
            .eq('client_id', client.id)
            .order('created_at', { ascending: false })
            .limit(1)
            .maybeSingle();

          if (fetchError) {
            console.error("Error fetching enrichment record for preview:", fetchError);
            setFieldsWithNewData(new Set());
            return;
          }

          if (enrichmentRecord && enrichmentRecord.enriched_data) {
            const newDataSet = compareClientDataWithEnriched(client, enrichmentRecord.enriched_data as EnrichedData, globalMappableFields);
            setFieldsWithNewData(newDataSet);
          } else {
            setFieldsWithNewData(new Set());
          }
        } catch (e) {
          console.error("Exception fetching enrichment for preview:", e);
          setFieldsWithNewData(new Set());
        }
      } else {
        setFieldsWithNewData(new Set());
      }
    };

    processClientForPreview();
  }, [client]);

  return fieldsWithNewData;
};

